import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NovelistProvider } from '../../providers/novelist/novelist';
import { Subject } from 'rxjs/Subject';
import { CoBibItemProvider } from '../../providers/co-bib-item/co-bib-item';
import { IlsProvider } from '../../providers/ils/ils';
import { AppState } from '../../config/state';
import { Ionic2RatingModule } from "ionic2-rating";

/**
 * Generated class for the CoNovelistComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-novelist',
  templateUrl: 'co-novelist.html',
  inputs: ['idents','mode']
})
export class CoNovelistComponent {
  public updateObserver: Subject<Array<number>>;
  @Input() idents: any;
  @Input() mode: string = "similarTitles";
  @Output() loaded: EventEmitter<any> = new EventEmitter<any>();
  currentModal: any;
  private items: Array<any>;

  constructor(private novelist:NovelistProvider, private bib:CoBibItemProvider, private ilsProvider : IlsProvider, private state: AppState) {
    setInterval(()=>this.update(), 500);//#TODO: fix this silly hack
  }
  showItem(isbn){
    this.currentModal = this.bib.showItemFromISBN(isbn, 'simple').then((newModal) => {
      // if (this.currentModal) this.currentModal.dismiss();
      return newModal;
    })
  }
  public update(){
    this.updateObserver.next();
  }
  ngOnInit(){
    this.updateObserver =new Subject();
  }
  ngAfterViewInit(){
    if(this.idents && this.idents.length>0){
      let done=false;
      this.idents.forEach(async ident => {
        if(done)return;
        let result;
        if(ident.type === 'bibId'){
          result = await this.ilsProvider.getBibDetailsFromId(ident.id);
        } else if(ident.type=='isbn'){
          result = await this.novelist.getItemDetailsFromISBN(ident.id);
        }else if(ident.type=='upc'){
          result = await this.novelist.getItemDetailsFromUPC(ident.id);
        }else if (ident.type=='barcode'){
          result = await this.novelist.getItemDetailsFromBarcode(ident.id);
        }
        // console.log(result)
        if(result && result[this.mode]){
          done=true;
          this.items = result[this.mode].map(item=>{
            // item.cover = `http://covers0.communico.co/isbn/o/${item.primaryISBN}.jpg`;
			item.cover = `https://${this.state.client.keyword}.libnet.info/getcover/${item.primaryISBN}`;

			// item.error = "http://placehold.it/100x150&text="+encodeURIComponent(item.title);
            item.error = "http://covers0.communico.co/gen/cover?title="+encodeURIComponent(item.title);
            return item;
          });
          this.loaded.emit(true);
        }
      });
    } else if (this.state.showNovelistOnLogout && this.state.novelistArray && this.state.novelistArray.length > 0){
      this.items = []
      this.state.novelistArray.forEach(book =>{
		if(book && !book[this.mode])return;
        book[this.mode].map(item=>{
        // item.cover = `http://covers0.communico.co/isbn/o/${item.primaryISBN}.jpg`;
		  item.cover = `https://${this.state.client.keyword}.libnet.info/getcover/${item.primaryISBN}`;
          item.error = "http://covers0.communico.co/gen/cover?title="+encodeURIComponent(item.title);
          this.items.push(item);
        });
        this.loaded.emit(true);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/co-novelist/co-novelist.ts